import { render, staticRenderFns } from "./quizzeshc.vue?vue&type=template&id=149da6bb&scoped=true&"
import script from "./quizzeshc.vue?vue&type=script&lang=js&"
export * from "./quizzeshc.vue?vue&type=script&lang=js&"
import style0 from "./quizzeshc.vue?vue&type=style&index=0&id=149da6bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149da6bb",
  null
  
)

export default component.exports